import { z } from 'zod'

/**
 * Job costing tracking status.
 * - NOT_TRACKED: Job is excluded from job costing workflow
 * - TRACKED: Job is included in job costing workflow
 */
export const JobCostingTrackingStatus = z.enum(['NOT_TRACKED', 'TRACKED'])
export type JobCostingTrackingStatus = z.infer<typeof JobCostingTrackingStatus>

/**
 * Get display name for tracking status
 */
export function getTrackingStatusDisplayName(status: JobCostingTrackingStatus): string {
  const displayNames: Record<JobCostingTrackingStatus, string> = {
    NOT_TRACKED: 'Not Tracked',
    TRACKED: 'Tracked',
  }
  return displayNames[status]
}
